import { IUser } from './../models/user.model';
import { ActionReducerMap } from '@ngrx/store';
import {  } from './search/reducer';
import { ActionTypes } from './search/actions';
import {} from './search/state';

import {
    createSelector,
    createFeatureSelector,
} from '@ngrx/store';


// The top level Echoes Player application interface
// each reducer is reponsible for manipulating a certain state
// export interface VervendoState {
//     user: IUser;
// }

export let VervendoActions = [
    ActionTypes,
];

// export interface VervendoState {
//   user: UserState.UserState;
// }
// export interface AppState {
//     state: { };
//  }

 export const reducers: ActionReducerMap<any> = {
//    user: routerReducer

 };

// export const selectTodoState = createFeatureSelector<UserState>('search');

// export const selectUserState = createSelector(selectTodoState, state => state.isLoggedIn);

// export const { selectAll: selectAllTodos } = userAdapter.getSelectors();
